import { lazy, Suspense } from 'react';
import { HeroSection } from '@/components/landing/HeroSection';

// Lazy load below-the-fold sections to reduce initial bundle
const PhilosophySection = lazy(() => import('@/components/landing/PhilosophySection').then(m => ({ default: m.PhilosophySection })));
const CapabilitiesSection = lazy(() => import('@/components/landing/CapabilitiesSection').then(m => ({ default: m.CapabilitiesSection })));
const IntelligenceSection = lazy(() => import('@/components/landing/IntelligenceSection').then(m => ({ default: m.IntelligenceSection })));
const RiskSection = lazy(() => import('@/components/landing/RiskSection').then(m => ({ default: m.RiskSection })));
const TestimonialsSection = lazy(() => import('@/components/landing/TestimonialsSection').then(m => ({ default: m.TestimonialsSection })));
const PricingSection = lazy(() => import('@/components/landing/PricingSection').then(m => ({ default: m.PricingSection })));
const FinalCTASection = lazy(() => import('@/components/landing/FinalCTASection').then(m => ({ default: m.FinalCTASection })));
const Footer = lazy(() => import('@/components/layout/Footer').then(m => ({ default: m.Footer })));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Minimal background - no excessive gradients */}
      <div className="fixed inset-0 bg-[#050505] pointer-events-none" />
      
      {/* Subtle top glow only */}
      <div className="fixed top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-foreground/[0.02] rounded-full blur-[150px] pointer-events-none" />

      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <PhilosophySection />
          <CapabilitiesSection />
          <IntelligenceSection />
          <RiskSection />
          <TestimonialsSection />
          <PricingSection />
          <FinalCTASection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
